import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { AuthContext } from "../../context/authContext/authContext";
import { Timeout } from "../../helpers/Timeout";
import { ClikMenu, Expander, ExpanderNotificaciones } from "../../helpers/menu";
import { FormatoJornada } from "../MedidorTiempos/FormatoJornada";
import { SocketContext } from "../../context/SocketContext";
// iport icons
import logoTotalProtect from "../../assets/img/logos/Total Protect blanco.png";
// import Spectrak from "../../assets/img/logos/spectral1023.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChevronRight,
  faPowerOff,
  faBars,
  faXmark,
  faTasks,
  faLockOpen,
  faDiagramSuccessor,
  faTruckMoving,
  faHouseUser,
  faPersonBooth,
  faUserClock,
  faUsers,
  faUserTie,
  faClock,
  faFileLines,
  faTruck,
  faDoorOpen,
  faShield,
  faShippingFast,
  faRoute,
  faFolderOpen,
  faKey,
  faChartLine,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";

/* Componente para la barra de navegación */

export const Navbar = () => {
  const {
    user,
    clearSesion,
    stateJornada,
    setStateJornada,
    stateTurno,
    setStateTurno,
    setStatusUsuarioActual,
    setEventosCarga,
  } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const { postRegistroHorario, getRegistroEventos, cerrarSesion } =
    useUnidades();
  const [encabezado, setEncabezado] = useState(
    document.title ? document.title : pathname
  );
  const [eventosRegistrados, setEventosRegistrados] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [listaPermisos, setListaPermisos] = useState([]);
  const { socket } = useContext(SocketContext);

  let date = new Date();
  var now = date.toLocaleTimeString("es-MX");

  useEffect(() => {
    // cargaRegistroEventos();
    if (user.rol === "Monitorista") {
      if (socket) {
        socket.emit("staffing");
      }
      loadInfo();
      play();
      if (stateJornada === "Comida" || stateJornada === "COMIDA") {
        const mostrarComida = document.getElementById("statusEvento");
        mostrarComida.style.display = "block";
        mostrarComida.style.color = "#0d6efd";
      }
      if (stateJornada === "Descanso" || stateJornada === "DESCANSO") {
        const mostrarDescanso = document.getElementById("statusEvento");
        mostrarDescanso.style.display = "block";
        mostrarDescanso.style.color = "#ffc107";
      }
    }

    // if(user.rol === "Administrador de cedis") {
    if (socket) {
      socket.emit("encargado_staffing");
    }
    // }

    if (!show) ClikMenu();
  }, []);
  useEffect(() => {
    setEncabezado(document.title ? document.title : pathname);
  }, [pathname, document.title]);
  const navigate = useNavigate();

  const handleLogout = async () => {
    let hora = Date.now();
    let resp = await cerrarSesion(user.id);

    if (resp.ok) {
      socket.emit("staffing");
      if (user.rol == "Administrador de cedis") {
        socket.emit("encargado_staffing");
      }
      clearSesion();
      navigate("/login", {
        replace: true,
      });

      localStorage.setItem("lastPath", "");

      return Swal.fire({
        title: "¡Hasta Luego!",
        text: resp.msg,
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      return Swal.fire({
        title: "¡Upss!",
        text: resp.msg,
        icon: "error",
      });
    }
  };

  Timeout();
  const titulo = (titulo) => {
    setEncabezado(titulo);
    return encabezado;
  };
  const { permisosMenu } = user;

  // const currentEvent = () => {

  //   if(eventosCarga){

  //   }

  // }

  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState("00:00:00");

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
        ":" +
        (minutes > 9 ? minutes : "0" + minutes) +
        ":" +
        (seconds > 9 ? seconds : "0" + seconds)
      );
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer("00:00:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = (e) => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + e);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only
  // useEffect(() => {
  //     // clearTimer(getDeadTime());
  // }, []);

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button
  const onClickReset = (e) => {
    clearTimer(getDeadTime(e));
  };

  const ejecutandoEventos = async () => {
    const eventosJornada = await getRegistroEventos(user.id);

    if (eventosJornada && eventosJornada.ok) {
      setEventosRegistrados(eventosJornada.registros);
      setEventosCarga(eventosJornada.registros);
      setListaPermisos(eventosJornada.permisos);
    }
  };

  const loadInfo = async () => {
    const eventosJornada = await getRegistroEventos(user.id);

    if (eventosJornada && eventosJornada.ok) {
      setListaPermisos(eventosJornada.permisos);
      setEventosCarga(eventosJornada.registros);
      if (eventosJornada.estatusUsuario.includes("Inicio")) {
        if (eventosJornada.estatusUsuario === "Inicio Comida") {
          let restaTotal = "";
          eventosJornada.registros.map(async (ultimoEvento) => {
            if (ultimoEvento.tipo_registro === "Inicio Comida") {
              restaTotal = await diferenciaTiemposEn2Fechas(
                ultimoEvento.fecha_hora
              );
              // console.log(restaTotal);

              if (Math.abs(restaTotal) >= 3600) {
                // onClickReset(Math.abs(0));
              } else {
                console.log(restaTotal);
                let tiempoRestante = restaTotal + 3600;
                onClickReset(Math.abs(tiempoRestante));
                console.log("si entro: comida");
              }
            }
          });
        }
        if (eventosJornada.estatusUsuario === "Inicio Descanso") {
          let restaTotal = "";
          eventosJornada.registros.map(async (ultimoEvento) => {
            if (ultimoEvento.tipo_registro === "Inicio Descanso") {
              restaTotal = await diferenciaTiemposEn2Fechas(
                ultimoEvento.fecha_hora
              );
              // console.log(restaTotal);

              if (Math.abs(restaTotal) >= 900) {
                // onClickReset(Math.abs(0));
              } else {
                console.log(restaTotal);
                let tiempoRestante = restaTotal + 900;
                onClickReset(Math.abs(tiempoRestante));
                console.log("si entro: descanso");
              }
            }
          });
        }
      }
    }
  };

  const diferenciaTiemposEn2Fechas = async (resDate) => {
    let dateE = new Date(resDate);
    let horaE = dateE.getHours();
    let minutosE = dateE.getMinutes();
    let segundosE = dateE.getSeconds();

    let horaRegistrada = horaE + ":" + minutosE + ":" + segundosE;
    const hora1 = horaRegistrada.split(":"),
      t1 = new Date();
    t1.setHours(hora1[0], hora1[1], hora1[2]);

    const Horas = (t1.getHours() - date.getHours()) * 60 * 60;
    const Minutos = (t1.getMinutes() - date.getMinutes()) * 60;
    const segundos = t1.getSeconds() - date.getSeconds();

    const restaTotal = Horas + Minutos + segundos;

    return restaTotal;
  };

  const handleAction = async (e, turnoActual) => {
    e.preventDefault();
    if (turnoActual === "COMIDA") {
      if (stateTurno.comida === false) {
        Swal.fire({
          title: "¡Seguro que deseas iniciar tu hora de comida",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(3);
            console.log("respuesta insert" + resp);
            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Inicio Comida");
              await ejecutandoEventos();

              let segundos = 3600;
              onClickReset(segundos);
              const mostrarComida = document.getElementById("statusEvento");
              mostrarComida.style.display = "block";

              const colorComida = document.getElementById("statusEvento");
              colorComida.style.color = "#0d6efd";

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#0d6efd";

              setStateTurno({ ...stateTurno, comida: true });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, comida: true })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
              setStateJornada(turnoActual);

              console.log(resp.msg);
              Swal.fire({
                title: "Comida",
                text: "Tu hora de comida ha iniciado a las" + " " + now,
                showConfirmButton: false,
                icon: "success",
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se inicia la hora de comida*");
          }
        });
      } else {
        Swal.fire({
          title: "¡Seguro que deseas finalizar tu hora de comida",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(4);

            if (resp.ok) {
              socket.emit("staffing");
              await ejecutandoEventos();
              setStatusUsuarioActual("Activo");

              clearTimer();
              const mostrarComida = document.getElementById("statusEvento");
              mostrarComida.style.display = "none";
              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#198754";

              setStateTurno({ ...stateTurno, comida: false });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, comida: false })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify("ACTIVO"));
              setStateJornada("ACTIVO");
              console.log(resp.msg);
              Swal.fire({
                icon: "success",
                title: "Comida",
                text: "Tu hora de comida finalizo a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });

              const ocultarbtncomida =
                document.getElementById("contenedor-comida");
              ocultarbtncomida.style.display = "none";
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se finaliza la hora de comida*");
          }
        });
      }
    }

    if (turnoActual === "DESCANSO") {
      e.preventDefault();
      if (stateTurno.descanso === false) {
        Swal.fire({
          title: "¡Seguro que deseas iniciar tu descanso",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(5);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Inicio Descanso");
              await ejecutandoEventos();

              let segundos = 900; // 900
              onClickReset(segundos);
              const mostrarDescanso = document.getElementById("statusEvento");
              mostrarDescanso.style.display = "block";

              const colorDescanso = document.getElementById("statusEvento");
              colorDescanso.style.color = "#ffc107";

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#ffc107";

              setStateTurno({ ...stateTurno, descanso: true });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, descanso: true })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
              setStateJornada(turnoActual);

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Descanso",
                text: "Inicio a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se inicia la hora de descanso*");
          }
        });
      } else {
        Swal.fire({
          title: "¡Seguro que deseas finalizar tu hora de descanso",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(6);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Activo");
              await ejecutandoEventos();

              clearTimer();
              const mostrarDescanso = document.getElementById("statusEvento");
              mostrarDescanso.style.display = "none";

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#198754";

              setStateTurno({ ...stateTurno, descanso: false });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, descanso: false })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify("ACTIVO"));
              setStateJornada("ACTIVO");

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Descanso",
                text: "Finalizo a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });

              // const ocultarbtndescanso = document.getElementById("contenedor-descanso");
              // ocultarbtndescanso.style.display = 'none';
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se finaliza la hora de descanso*");
          }
        });
      }
    }

    if (turnoActual === "SERVICIO MEDICO") {
      e.preventDefault();
      if (stateTurno.servicio_medico === false) {
        Swal.fire({
          title: "¡Seguro que deseas iniciar un permiso por servicio medico",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(12);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Inicio Servicio Medico");
              await ejecutandoEventos();
              // let segundos = 100; // 900
              // onClickReset(segundos);
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='block';

              // const colorDescanso = document.getElementById("statusEvento");
              // colorDescanso.style.color='#ffc107';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#f59a18";

              setStateTurno({ ...stateTurno, servicio_medico: true });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, servicio_medico: true })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
              setStateJornada(turnoActual);

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Servicio Medico",
                text: "Inicio a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se inicia el permiso para el servicio medico*");
          }
        });
      } else {
        Swal.fire({
          title: "¡Seguro que deseas finalizar tu permiso por servicio medico",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(13);

            if (resp.ok) {
              socket.emit("staffing");
              await ejecutandoEventos();
              setStatusUsuarioActual("Activo");

              // clearTimer();
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='none';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#198754";

              setStateTurno({ ...stateTurno, servicio_medico: false });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, servicio_medico: false })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify("ACTIVO"));
              setStateJornada("ACTIVO");

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Servicio Medico",
                text: "Finalizo a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });

              // const ocultarbtndescanso = document.getElementById("contenedor-descanso");
              // ocultarbtndescanso.style.display = 'none';
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se finaliza el permiso de servicio medico*");
          }
        });
      }
    }

    if (turnoActual === "PERMISO") {
      e.preventDefault();
      if (stateTurno.permiso === false) {
        var options = {};
        if (listaPermisos) {
          listaPermisos.map(
            (elemento) => (options[elemento.permiso] = elemento.permiso)
          );
        }

        Swal.fire({
          title: "Para iniciar tu permiso, indica el motivo",
          // text: "¿Confirmar?",
          // icon: 'warning',
          input: "select",
          inputOptions: options,
          // inputOptions: (
          //   listaPermisos.map((elemento) => (
          //     options[elemento.permiso] = elemento.permiso
          //   ))
          // ),
          inputPlaceholder: "Selecciona el permiso",
          showCancelButton: true,
          confirmButtonText: "Iniciar",
          cancelButtonText: "Cancelar",
          inputValidator: async (value) => {
            const resp = await actualizarEvento(9, value);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Inicio Permiso");
              await ejecutandoEventos();
              // let segundos = 100; // 900
              // onClickReset(segundos);
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='block';

              // const colorDescanso = document.getElementById("statusEvento");
              // colorDescanso.style.color='#ffc107';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#2c6ca8";

              setStateTurno({ ...stateTurno, permiso: true });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, permiso: true })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
              setStateJornada(turnoActual);

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Permiso",
                text: "Inicio a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          },
        });
        // .then(async resultado => {
        //     if (resultado.value) {

        //       const resp = await actualizarEvento(9);

        //       if(resp.ok){

        //         setStatusUsuarioActual("Inicio Permiso");
        //         await ejecutandoEventos();
        //         // let segundos = 100; // 900
        //         // onClickReset(segundos);
        //         // const mostrarDescanso =document.getElementById("statusEvento");
        //         // mostrarDescanso.style.display='block';

        //         // const colorDescanso = document.getElementById("statusEvento");
        //         // colorDescanso.style.color='#ffc107';

        //         const iconoJornada =document.getElementById("iconoJornada");
        //         iconoJornada.style.background='#2c6ca8';

        //         setStateTurno({...stateTurno, permiso: true});
        //         localStorage.setItem("stateTurno", JSON.stringify({...stateTurno, permiso: true}));
        //         // Hicieron click en "Sí"
        //         localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
        //         setStateJornada(turnoActual);

        //         console.log(resp.msg);
        //         Swal.fire({
        //             // position: 'top-end',
        //             icon: 'success',
        //             title: 'Permiso',
        //             text: 'Inicio a las: ' + now,
        //             showConfirmButton: false,
        //             timer: 3000
        //         });

        //       }else{
        //         Swal.fire({
        //           title: "Error",
        //           text: resp.msg,
        //           icon: "error",
        //         });
        //       }

        //     } else {
        //         // Dijeron que no
        //         console.log("*NO se inicia el permiso*");
        //     }
        // });
      } else {
        Swal.fire({
          title: "¡Seguro que deseas finalizar tu permiso",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(10);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Activo");
              await ejecutandoEventos();
              // clearTimer();
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='none';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#198754";

              setStateTurno({ ...stateTurno, permiso: false });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, permiso: false })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify("ACTIVO"));
              setStateJornada("ACTIVO");

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Permiso",
                text: "Finalizo a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se finaliza el permiso*");
          }
        });
      }
    }

    if (turnoActual === "SANITARIO") {
      e.preventDefault();
      if (stateTurno.sanitario === false) {
        Swal.fire({
          title: "¡Seguro que deseas iniciar un permiso para ir al sanitario",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(16);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Inicio Sanitario");
              await ejecutandoEventos();

              // let segundos = 100; // 900
              // onClickReset(segundos);
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='block';

              // const colorDescanso = document.getElementById("statusEvento");
              // colorDescanso.style.color='#ffc107';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#21dccc";

              setStateTurno({ ...stateTurno, sanitario: true });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, sanitario: true })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
              setStateJornada(turnoActual);

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Sanitario",
                text: "Inicio a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se inicia el permiso para ir al sanitario*");
          }
        });
      } else {
        Swal.fire({
          title: "¡Seguro que deseas finalizar tu permiso para ir al sanitario",
          text: "¿Confirmar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "Cancelar",
        }).then(async (resultado) => {
          if (resultado.value) {
            const resp = await actualizarEvento(17);

            if (resp.ok) {
              socket.emit("staffing");
              setStatusUsuarioActual("Activo");
              await ejecutandoEventos();

              // clearTimer();
              // const mostrarDescanso =document.getElementById("statusEvento");
              // mostrarDescanso.style.display='none';

              const iconoJornada = document.getElementById("iconoJornada");
              iconoJornada.style.background = "#198754";

              setStateTurno({ ...stateTurno, sanitario: false });
              localStorage.setItem(
                "stateTurno",
                JSON.stringify({ ...stateTurno, sanitario: false })
              );
              // Hicieron click en "Sí"
              localStorage.setItem("stateJornada", JSON.stringify("ACTIVO"));
              setStateJornada("ACTIVO");

              console.log(resp.msg);
              Swal.fire({
                // position: 'top-end',
                icon: "success",
                title: "Sanitario",
                text: "Finalizo a las: " + now,
                showConfirmButton: false,
                timer: 3000,
              });

              // const ocultarbtndescanso = document.getElementById("contenedor-descanso");
              // ocultarbtndescanso.style.display = 'none';
            } else {
              Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
              });
            }
          } else {
            // Dijeron que no
            console.log("*NO se finaliza el permiso para ir al sanitario*");
          }
        });
      }
    }

    if (turnoActual === "INACTIVO") {
      Swal.fire({
        title: "¡Seguro que deseas finalizar tu jornada",
        text: "¿Confirmar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "Cancelar",
      }).then(async (resultado) => {
        if (resultado.value) {
          const resp = await actualizarEvento(11);

          if (resp.ok) {
            socket.emit("staffing");
            const iconoJornada = document.getElementById("iconoJornada");
            iconoJornada.style.background = "#dc3545";

            setStateTurno({ ...stateTurno, finalizarJornada: true });
            localStorage.setItem(
              "stateTurno",
              JSON.stringify({ ...stateTurno, finalizarJornada: true })
            );
            // Hicieron click en "Sí"
            localStorage.setItem("stateJornada", JSON.stringify(turnoActual));
            setStateJornada(turnoActual);

            console.log(resp.msg);
            Swal.fire({
              icon: "success",
              title: "Finalizando tu Jornada",
              text: "Terminando tu sesión a las: " + now,
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(function () {
              // handleLogout();
              clearSesion();

              navigate("/login", {
                replace: true,
              });

              localStorage.setItem("lastPath", "");
              // resp = cerrarSesion(user.id);
              // if (resp.ok) {
              return Swal.fire({
                title: "¡Hasta Luego!",
                text: resp.msg,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              // }
            }, 5000);
          } else {
            Swal.fire({
              title: "Error",
              text: resp.msg,
              icon: "error",
            });
          }
        } else {
          // Dijeron que no
          console.log("*NO finaliza la jornada*");
        }
      });
    }
  };

  // function handleAction(event) {
  //   onClickReset();
  // }
  // -----------------------------------------------------------------------

  function TimerDisplay(props) {
    function secondsToHMS(value) {
      const hours2 = Math.floor(value / 3600);
      const minutes2 = Math.floor((value % 3600) / 60);
      const seconds2 = Math.floor((value % 3600) % 60);
      const firstZero = (num) => ("0" + num).slice(-2);

      return [hours2, minutes2, seconds2].map(firstZero).join(":");
    }
    return <h1 className="h1 display-4 pb-3">{secondsToHMS(props.value)}</h1>;
  }

  function Button({ iconName, text, btnClass, onClick }) {
    return (
      <button type="button" className={"btn " + btnClass} onClick={onClick}>
        <i className={"fa " + iconName}></i>
        {text}
      </button>
    );
  }
  const getNow = () => new Date().getTime();

  const [time, setTime] = useState(0);
  const [timerOn, setTimerOn] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [pauseDiff, setPauseDiff] = useState(0);
  const intervalIdRef = useRef(0);

  const refreshAndStop = () => {
    setTimerOn(false);
    setTime(0);
    setStartTime(0);
    setPauseDiff(0);
  };

  const play = () => {
    setTimerOn(true);
    setStartTime(getNow());
  };

  const pause = () => {
    setTimerOn(false);
    setPauseDiff(getNow() - startTime);
  };

  useEffect(async () => {
    // const Jornada = await getRegistroEventos(user.id);
    if (user.rol === "Monitorista") {
      await getRegistroEventos(user.id).then((res) => {
        // let fechaJornada = Jornada.inicio;
        let fechaJornada = new Date(res.inicio);
        // console.log("fechaJornada: "+fechaJornada);
        let diferencia = fechaJornada.getTime() - date.getTime();

        let horaJornada = fechaJornada.getHours();
        let minutosJornada = fechaJornada.getMinutes();
        let segundosJornada = fechaJornada.getSeconds();

        // console.log("fechaJornada: "+horaJornada+":"+minutosJornada+":"+segundosJornada);

        let horaEntradaRegistrada =
          horaJornada + ":" + minutosJornada + ":" + segundosJornada;
        // let horaEntradaRegistrada = Jornada.inicio.substring(11,19);

        const hora1 = horaEntradaRegistrada.split(":"),
          t1 = new Date();
        t1.setHours(hora1[0], hora1[1], hora1[2]);

        const Horas = (t1.getHours() - date.getHours()) * 60 * 60 * 1000;
        const Minutos = (t1.getMinutes() - date.getMinutes()) * 60 * 1000;
        const segundos = (t1.getSeconds() - date.getSeconds()) * 1000;

        const restaTotal = Horas + Minutos + segundos;

        // setPauseDiff(Math.abs(restaTotal));
        setPauseDiff(Math.abs(diferencia));
        // console.log("restaTotal: "+restaTotal);
        // console.log("restaTotal222222: "+diferencia);

        if (restaTotal && timerOn) {
          setCargando(true);
          if (timerOn) {
            intervalIdRef.current = setInterval(() => {
              setTime(
                ((getNow() - startTime + Math.abs(diferencia)) / 1000) | 0
              );
            }, 1000);
          } else {
            clearInterval(intervalIdRef.current);
          }
        }

        if (cargando) {
          console.log("hola ya cargo");
        }

        return () => clearInterval(intervalIdRef.current);
      });

      // setPauseDiff(Math.abs(restaTotal));
      // cargaRegistroEventos();

      // if (timerOn && loading) {
      //   intervalIdRef.current = setInterval(() => {
      //     // setTime(((getNow() - startTime + 1800000) / 1000) | 0);
      //     setTime(((getNow() - startTime + pauseDiff) / 1000) | 0);
      //   }, 1000);
      // } else {
      //   clearInterval(intervalIdRef.current);
      // }

      // return () => clearInterval(intervalIdRef.current);
    }
  }, [timerOn]);

  // useEffect(() => {
  //   if (time === 28800) {
  //     Swal.fire({
  //       title: "¡Alerta!",
  //       text: "Su hora de comida inicia en 5 minutos!",
  //       icon: "success",
  //     });
  //   }
  // }, [time]);

  useEffect(() => {
    if (stateJornada === "DESCANSO") {
      if (timer === "00:00:00") {
        Swal.fire({
          title: "¡Ups!",
          text: "El tiempo de descanso ya termino!",
          icon: "error",
        });
        // alert("3 minutos!");
      }
    }
  }, [timer]);

  const actualizarEvento = async (accion, tipoPermiso) => {
    let date = new Date();
    console.log(date.toUTCString());
    // var now = fechaHoy.toLocaleTimeString('es-MX');

    let usuario = user.id;
    let resp = await postRegistroHorario({
      usuario_turno_id: usuario,
      fecha_hora: date.toUTCString(),
      cat_tipo_registro_id: accion,
      tipo_permiso: tipoPermiso,
    });

    return resp;
  };

  // --------------------------------------------------------------------------------------------

  return (
    <>
      <div className="nav-top">
        <div className="text-header header-menu" id="title-nav">
          {" "}
          {encabezado}{" "}
        </div>
        {user.rol === "Monitorista" && (
          <>
            <div id="formJornadaLaboral">
              <h2 id="contador">{stateJornada}</h2>
              <FontAwesomeIcon
                icon={faClock}
                id="iconoJornada"
                className={"pull-right f12 " + stateJornada}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasJornada"
                aria-controls="offcanvasJornada"
              />
              <FormatoJornada
                onAction={handleAction}
                padreAHijo={eventosRegistrados ? eventosRegistrados : []}
              ></FormatoJornada>
            </div>
            <div className="jumbotron mt-5" id="tiempo">
              {timerOn ? <TimerDisplay value={time} /> : ""}
              <p id="statusEvento">{timer}</p>
            </div>
          </>
        )}

        <nav
          id="vertical-menu-wrapper"
          className={`vertical-menu-wrapper vertical-menu-wrapper-add`}
        >
          <div>
            <div className="d-flex flex-column vertical-menu-logo">
              <div className="sidebar-header text-center">
                <img
                  id="menu"
                  src={logoTotalProtect}
                  alt="logo menu"
                  width="85%"
                />
              </div>
              <span
                onClick={() => {
                  setShow(!show);
                  ClikMenu();
                }}
                id="iconoMenu"
                className="open-menu-btn padding-menu"
              >
                {show ? (
                  <FontAwesomeIcon icon={faXmark} className="pull-right" />
                ) : (
                  <FontAwesomeIcon icon={faBars} className="pull-right" />
                )}
              </span>
            </div>
          </div>
          <div id="optionsMenu">
            <ul
              className="vertical-menu nav nav-pills flex-column"
              style={{ overflowY: "auto" }}
            >
              <li id="NombreUsuario">{user.name}</li>
              <small className="white">
                {user.rol}{" "}
                {user.roles_id === 1 || user.roles_id === 4
                  ? `de ${user.negocio}`
                  : user.roles_id === 2
                    ? "de Total Protect"
                    : ""}
              </small>
              <li>
                <Link to={""} onClick={handleLogout} className="cerrarSesion">
                  {" "}
                  CERRAR SESIÓN{" "}
                  <FontAwesomeIcon
                    icon={faPowerOff}
                    className="pull-right f12"
                  />{" "}
                </Link>
              </li>
              {user.rol === "Monitorista" && (
                <li>
                  <NavLink
                    to="/select-cedis"
                    className="link-hover"
                    onClick={() => titulo("Selecciona tus cedis")}
                  >
                    {" "}
                    SELECCIONA TUS CEDIS
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}
              <hr />
              {permisosMenu.programarRuta && (
                <>
                  <li>
                    <NavLink
                      to="/programar-ruta"
                      className="link-hover"
                      onClick={() => titulo("PROGRAMAR RUTA")}
                    >
                      {" "}
                      PROGRAMAR RUTA
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/viajes-ruta"
                      className="link-hover"
                      onClick={() => titulo("VIAJES EN RUTA")}
                    >
                      {" "}
                      VIAJES EN RUTA
                      <FontAwesomeIcon
                        icon={faTruck}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.programarSalida && (
                <li>
                  <NavLink
                    to="/programar-salida"
                    className="link-hover"
                    onClick={() => titulo("PROGRAMAR SALIDA")}
                  >
                    {" "}
                    PROGRAMAR SALIDA
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}
              {permisosMenu.enRuta && (
                <li>
                  <NavLink
                    to="/enRuta"
                    className="link-hover"
                    onClick={() => titulo("EN RUTA")}
                  >
                    {" "}
                    EN RUTA
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}
              {permisosMenu.bitacora && (
                <>
                  <li>
                    <NavLink
                      to="/bitacora"
                      onClick={() => titulo("BITACORA")}
                      className="link-hover"
                    >
                      {" "}
                      BITACORA
                      <FontAwesomeIcon
                        icon={faTasks}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}

              {permisosMenu.tablero && (
                <>
                  <li>
                    <NavLink
                      to="/tablero"
                      onClick={() => titulo("TABLERO GERENCIAL")}
                      className="link-hover"
                    >
                      {" "}
                      TABLERO GERENCIAL
                      <FontAwesomeIcon
                        icon={faDiagramSuccessor}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.autos && (
                <>
                  <li>
                    <NavLink
                      to="/autos"
                      onClick={() => titulo("TABLERO DE AUTOS")}
                      className="link-hover"
                    >
                      {" "}
                      AUTOS
                      <FontAwesomeIcon
                        icon={faTasks}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.tableroAdministracion && (
                <li>
                  <NavLink
                    to="/tablero-gerencial"
                    onClick={() => titulo("TABLERO DE ADMINISTRACION")}
                    className="link-hover"
                  >
                    {" "}
                    TABLERO DE ADMINISTRACION
                    <FontAwesomeIcon
                      icon={faTasks}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}

              {permisosMenu.administracionViajes && (
                <li>
                  <NavLink
                    to="/edicion-viaje"
                    onClick={() => titulo("EDICION DE VAJES")}
                    className="link-hover"
                  >
                    {" "}
                    ADMINISTRACION DE VIAJES
                    <FontAwesomeIcon
                      icon={faRoute}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}
              {permisosMenu.motos && (
                <>
                  <li>
                    <NavLink
                      to="/motos"
                      onClick={() => titulo("TABLERO DE MOTOS")}
                      className="link-hover"
                    >
                      {" "}
                      MOTOS
                      <FontAwesomeIcon
                        icon={faTasks}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.camiones && (
                <>
                  <li>
                    <NavLink
                      to="/camiones"
                      onClick={() => titulo("TABLERO DE CAMIONES")}
                      className="link-hover"
                    >
                      {" "}
                      CAMIONES
                      <FontAwesomeIcon
                        icon={faTasks}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.generacionCodigos && (
                <>
                  <li>
                    <NavLink
                      to="/generacionCodigos"
                      onClick={() => titulo("GENERACION DE CÓDIGOS")}
                      className="link-hover"
                    >
                      {" "}
                      GENERACION DE CÓDIGOS
                      <FontAwesomeIcon
                        icon={faKey}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.administracionUidades && (
                <>
                  <li>
                    <NavLink
                      to="/admin-unidades"
                      onClick={() => titulo("ADMINISTRACIÓN DE UNIDADES")}
                      className="link-hover"
                    >
                      {" "}
                      ADMINISTRACIÓN DE UNIDADES
                      <FontAwesomeIcon
                        icon={faTruckMoving}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.eventosDeSeguridad && (
                <>
                  <li>
                    <NavLink
                      to="/eventos-de-seguridad"
                      onClick={() => titulo("EVENTOS DE SEGURIDAD")}
                      className="link-hover"
                    >
                      {" "}
                      EVENTOS DE SEGURIDAD
                      <FontAwesomeIcon
                        icon={faShield}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.reporteEventosDeSeguridad && (
                <>
                  <li>
                    <NavLink
                      to="/reporte-eventos-de-seguridad"
                      onClick={() => titulo("REPORTE EVENTOS DE SEGURIDAD")}
                      className="link-hover"
                    >
                      {" "}
                      REPORTE EVENTOS DE SEGURIDAD
                      <FontAwesomeIcon
                        icon={faShield}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.boletinados && (
                <>
                  <li>
                    <NavLink
                      to="/eventos-boletinados"
                      onClick={() => titulo("EVENTOS BOLETINADOS")}
                      className="link-hover"
                    >
                      {" "}
                      REGISTROS BOLETINADOS
                      <FontAwesomeIcon
                        icon={faShield}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/dashboard-cad"
                      onClick={() => titulo("DASBOARD SEGURIDAD")}
                      className="link-hover"
                    >
                      {" "}
                      DASHBOARD CAD
                      <FontAwesomeIcon
                        icon={faChartLine}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.gestionDeReportes && (
                <>
                  <li>
                    <NavLink
                      to="/gestion-reportes"
                      onClick={() => titulo("GESTION DE REPORTES")}
                      className="link-hover"
                    >
                      {" "}
                      GESTION DE REPORTES
                      <FontAwesomeIcon
                        icon={faShield}
                        className="pull-right f12"
                      />
                    </NavLink>
                  </li>
                </>
              )}
              {permisosMenu.TableroGerencial && (
                <li>
                  <NavLink
                    to="/bitacora-administracion"
                    onClick={() => titulo("BITACORA DE ADMINISTRACION")}
                    className="link-hover"
                  >
                    {" "}
                    BITACORA DE ADMINISTRACION
                    <FontAwesomeIcon
                      icon={faDiagramSuccessor}
                      className="pull-right f12"
                    />
                  </NavLink>
                </li>
              )}
              {permisosMenu.admin && (
                <>
                  {user.negocio_id && (
                    <li>
                      <NavLink
                        to="#"
                        onClick={ExpanderNotificaciones}
                        className="link-hover"
                        data-toggle="collapse"
                        role="button"
                        aria-controls="collapseNotificaciones"
                      >
                        {" "}
                        NOTIFICACIONES
                        <FontAwesomeIcon
                          icon={faLockOpen}
                          className="pull-right f12"
                        />
                      </NavLink>
                    </li>
                  )}
                  <ul
                    className="collapse"
                    id="collapseNotificaciones"
                    style={{ height: "auto" }}
                  >
                    <li>
                      <NavLink
                        to="/notificaciones-log"
                        onClick={() => titulo("LOG BOT")}
                        className="link-hover"
                      >
                        {" "}
                        LOG BOT
                        <FontAwesomeIcon
                          icon={faUsers}
                          className="pull-right f12"
                        />
                      </NavLink>
                    </li>
                  </ul>

                  <div>
                    <li>
                      <NavLink
                        to="#"
                        onClick={Expander}
                        className="link-hover"
                        data-toggle="collapse"
                        role="button"
                        aria-controls="collapseExample"
                      >
                        {" "}
                        ADMINISTRACIÓN
                        <FontAwesomeIcon
                          icon={faLockOpen}
                          className="pull-right f12"
                        />
                      </NavLink>
                    </li>
                    <ul
                      className="collapse"
                      id="collapseExample"
                      style={{ height: "auto" }}
                    >
                      {user.negocio_id === 1 ||
                        user.negocio_id === "1" ||
                        user.negocio_id === 2 ||
                        user.negocio_id === "2" ? (
                        <>
                          <li>
                            <NavLink
                              to="/tablero-clientes"
                              onClick={() => titulo("TABLERO DE CLIENTES")}
                              className="link-hover"
                            >
                              {" "}
                              CLIENTES
                              <FontAwesomeIcon
                                icon={faUserTie}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                        </>
                      ) : (
                        ""
                      )}

                      <li>
                        <NavLink
                          to="/tablero-usuarios"
                          onClick={() => titulo("TABLERO DE USUARIOS")}
                          className="link-hover"
                        >
                          {" "}
                          USUARIOS
                          <FontAwesomeIcon
                            icon={faUsers}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/tablero-tripulantes"
                          onClick={() => titulo("TABLERO DE TRIPULANTES")}
                          className="link-hover"
                        >
                          {" "}
                          TRIPULANTES
                          <FontAwesomeIcon
                            icon={faPersonBooth}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/tablero-tiendas"
                          onClick={() => titulo("TABLERO DE TIENDAS")}
                          className="link-hover"
                        >
                          {" "}
                          TIENDAS
                          <FontAwesomeIcon
                            icon={faUserClock}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/tablero-cedis"
                          onClick={() => titulo("TABLERO DE CEDIS")}
                          className="link-hover"
                        >
                          {" "}
                          CEDIS
                          <FontAwesomeIcon
                            icon={faHouseUser}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/tablero-unidades"
                          onClick={() => titulo("TABLERO DE UNIDADES")}
                          className="link-hover"
                        >
                          {" "}
                          UNIDADES
                          <FontAwesomeIcon
                            icon={faTruckMoving}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      {user.negocio_id === 1 ||
                        user.negocio_id === "1" ||
                        user.negocio_id === 2 ||
                        user.negocio_id === "2" ? (
                        <>
                          <li>
                            <NavLink
                              to="/tablero-staffing"
                              onClick={() => titulo("STAFFING")}
                              className="link-hover"
                            >
                              {" "}
                              STAFFING
                              <FontAwesomeIcon
                                icon={faUsers}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/tablero-session-usuarios"
                              onClick={() => titulo("SESSION USUARIOS")}
                              className="link-hover"
                            >
                              {" "}
                              USUARIOS SESSIÓN
                              <FontAwesomeIcon
                                icon={faUsers}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/tablero-productivity"
                              onClick={() => titulo("REPORTE DE PRODUCTIVIDAD")}
                              className="link-hover"
                            >
                              {" "}
                              REPORTE DE PRODUCTIVIDAD
                              <FontAwesomeIcon
                                icon={faFileLines}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/tablero-productivity-user"
                              onClick={() =>
                                titulo("REPORTE DE PRODUCTIVIDAD POR USUARIO")
                              }
                              className="link-hover"
                            >
                              {" "}
                              REPORTE DE PRODUCTIVIDAD POR USUARIO
                              <FontAwesomeIcon
                                icon={faFileLines}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/mdvrs"
                              onClick={() => titulo("ADMINISTRACION DE MDVRS")}
                              className="link-hover"
                            >
                              {" "}
                              ADMINISTRACION DE MDVRS
                              <FontAwesomeIcon
                                icon={faVideo}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/camaras"
                              onClick={() => titulo("REPORTE DE CAMARAS")}
                              className="link-hover"
                            >
                              {" "}
                              REPORTE DE CAMARAS
                              <FontAwesomeIcon
                                icon={faVideo}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li>
                          {/* <li>
                            <NavLink
                              to="/tablero-reporte-viajes"
                              onClick={() =>
                                titulo("REPORTE DE VIAJES EN RUTA")
                              }
                              className="link-hover"
                            >
                              {" "}
                              REPORTE DE VIAJES EN RUTA
                              <FontAwesomeIcon
                                icon={faTruckMoving}
                                className="pull-right f12"
                              />
                            </NavLink>
                          </li> */}
                        </>
                      ) : (
                        " "
                      )}
                      <li>
                        <NavLink
                          to="/tablero-contingencia"
                          onClick={() =>
                            titulo("CONTINGENCIA DE APERTURAS POR CÓDIGOS")
                          }
                          className="link-hover"
                        >
                          {" "}
                          CONTINGENCIA DE APERTURAS POR CÓDIGOS
                          <FontAwesomeIcon
                            icon={faDoorOpen}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/tablero-status-enRutas"
                          onClick={() => titulo("ADMINISTRACIÓN DE ESTATUS DE UNIDADES")}
                          className="link-hover"
                        >
                          {" "}
                          ESTATUS DE UNIDADES EN RUTA
                          <FontAwesomeIcon
                            icon={faShippingFast}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/edicion-viaje"
                          onClick={() => titulo("EDICION DE VAJES")}
                          className="link-hover"
                        >
                          {" "}
                          ADMINISTRACION DE VIAJES
                          <FontAwesomeIcon
                            icon={faRoute}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/protocolos"
                          onClick={() => titulo("PROTOCOLOS DE SEGURIDAD")}
                          className="link-hover"
                        >
                          {" "}
                          ADMINISTRACION DE PROTOCOLOS
                          <FontAwesomeIcon
                            icon={faFolderOpen}
                            className="pull-right f12"
                          />
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </ul>
          </div>
        </nav>
      </div>

      {show ? (
        <div
          className="col-12"
          style={{
            height: "200%",
            zIndex: 99,
            position: "fixed",
            backgroundColor: "rgba(255,255,255,0.5)",
            marginTop: "-5rem",
          }}
          onClick={() => {
            setShow(!show);
            ClikMenu();
          }}
        >
          &nbsp;
        </div>
      ) : (
        ""
      )}
    </>
  );
};
